import React from "react";
import TextOption from "./textOption";
import classes from './text.module.css';


const TextList = ({posts,title}) => {
    return (
        <div className={classes.contBlock}>
            <h2>{title}</h2>
            {posts.map((post, index) => 
                <TextOption number={index +1} post={post} key={post.id} />
            )}
        </div>
    )
}

export default TextList;